import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../theme-provider-component/theme-provider-component";
import { Button } from "../ui/button";
import { cn } from "../../utils/utils";


export function ThemeToggle({ className }: { className?: string }) {
    const { theme, setTheme } = useTheme();
    const { t } = useTranslation("common");

    return (
        <Button
            variant="ghost"
            size="icon"
            onClick={() => setTheme(theme === "light" ? "dark" : "light")}
            className={cn("rounded-full", className)}
        >
            <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
            <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
            <span className="sr-only">{t("ui.toggleTheme", "Alternar tema")}</span>
        </Button>
    );
}
